
/**
 * @Author: Zewei
 * @Date:   2018-01-23T14:34:28+08:00
* @Last modified by:   Zewei
* @Last modified time: 2018-01-26T10:40:54+08:00
 */

import React, { Component } from 'react';
import { Modal, Button, Row, Col, Select, Input, TreeSelect, Form } from 'antd';
// import './roleManagementModal.less';
// import moment from 'moment';

const Option = Select.Option;
const FormItem = Form.Item;
// const FormItem = Form.Item;
const { TreeNode } = TreeSelect;

// const formItemLayout = {
//     labelCol: { span: 6 },
//     wrapperCol: { span: 14 },
// };

class UsereModal extends Component {
  state = {
    user_name: '',
    email: "",
    birthday: "",
    phone: "",
    department_name: ""

  }
  renderTreeNodes = (data) => {
    return data.map((item) => {
      if (item.children) {
        return (
          <TreeNode value={`${item.id}`} title={item.name} key={item.id} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode {...item} />;
    });
  }

  handleJobNumberChange = (value) => {
    // console.log(value)
    this.props.employeeUserList.Data.forEach((item) => {
      if (item.job_number === value) {
        // console.log(item);
        // this.setState({
        //     business_name: item.business_name,
        //     business_level: item.business_level
        // })
        this.props.form.setFieldsValue({
          // this.props.form.setFields({
          user_name: item.english_name,
          email: item.email,
          birthday: item.birthday,
          phone: item.cell_phone,
          department_name: item.department_name,
          department_id: item.department_id
        })
        this.setState({ department_id: item.department_id })
      }
    })

  }
  handleUpdateUser = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values = { ...values }
        values.id = this.props.userDetail.id
        if (values.code === this.props.userDetail.code) {
          values.department_id = this.props.userDetail.department_id
        }
        else {
          values.department_id = this.state.department_id
        }
        if (values.password === this.props.userDetail.password) {
          values.password = "";
        }
        // console.log(values);
        this.props.handleUpdateUser(values)
      }
    })
  }
  handleCreateNewUser = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values = { ...values }
        values.department_id = this.state.department_id
        console.log(values);
        this.props.handleCreateNewUser(values)
      }
    })
  }
  // handleSelectChange=(v)=>{}


  render() {
    const { initUser, modalVisible, userEditModalVisible, title, userDetail,
      // departmentsList, handleCreateNewUser, handleInputChange, onDatePickerChange, handleUpdateUser,
      employeeUserList, handleCodeChange, handleCodeSearch,
      handleCancel, handleSelectChange,
      /*handleDepartmentSelectChange*/
    } = this.props;
    const { getFieldDecorator } = this.props.form;
    let submitBtn = <Button key="submit" type="primary" onClick={this.handleCreateNewUser}>提交</Button>,
      visible = modalVisible;
    if (userDetail) {
      submitBtn = <Button key="submit" type="primary" onClick={this.handleUpdateUser}>提交</Button>;
      visible = userEditModalVisible;
    }

    return (
      <Modal
        title={title}
        visible={visible}
        onOk={this.handleCreateNewUser}
        onCancel={handleCancel}
        width={730}
        className="addRoleModal"
        footer={[
          <Button key="back" onClick={handleCancel}>关闭</Button>,
          submitBtn,
        ]}
        destroyOnClose={true}
      >
        <div>
          <Form className="ant-advanced-search-form">
            <Row>
              <Col span={4} style={{ textAlign: "right", paddingRight: "10px", lineHeight: "32px" }}>
                工号：
                        </Col>
              <Col span={8}>
                <FormItem>
                  {getFieldDecorator('code', {
                    rules: [{ required: true, message: '请输入工号' }],
                    initialValue: userDetail ? userDetail.code : ''
                  })(
                    <Select
                      mode="combobox"
                      filterOption={false}
                      onChange={handleCodeChange}
                      onSearch={handleCodeSearch}
                      placeholder="请输入工号"
                      onSelect={this.handleJobNumberChange}
                      style={{ width: "200px" }}>
                      {
                        employeeUserList && employeeUserList.Data.map(item => {
                          return (
                            <Select.Option key={item.job_number} value={item.job_number}>
                              {item.job_number}
                            </Select.Option>
                          )
                        }
                        )
                      }
                    </Select>
                  )}
                </FormItem>
              </Col>
              <Col span={4} style={{ textAlign: "right", paddingRight: "10px", lineHeight: "32px" }}>
                用户名：
                        </Col>
              <Col span={8}>
                <FormItem>
                  {getFieldDecorator('user_name', {
                    rules: [{ required: true, message: '请更改花名册' }],
                    initialValue: userDetail ? userDetail.user_name : null
                  })(
                    <Input disabled style={{ width: "200px" }} />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={4} style={{ textAlign: "right", paddingRight: "10px", lineHeight: "32px" }}>
                邮箱：
                        </Col>
              <Col span={8}>
                <FormItem>
                  {getFieldDecorator('email', {
                    rules: [{ required: true, message: '请更改花名册' }],
                    initialValue: userDetail ? userDetail.email : null
                  })(
                    <Input disabled style={{ width: "200px" }} />
                  )}
                </FormItem>
              </Col>
              <Col span={4} style={{ textAlign: "right", paddingRight: "10px", lineHeight: "32px" }}>
                生日：
                        </Col>
              <Col span={8}>
                <FormItem>
                  {getFieldDecorator('birthday', {
                    rules: [{ required: true, message: '请更改花名册' }],
                    initialValue: userDetail ? userDetail.birthday : null
                  })(
                    <Input disabled style={{ width: "200px" }} />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={4} style={{ textAlign: "right", paddingRight: "10px", lineHeight: "32px" }}>
                电话：
                        </Col>
              <Col span={8}>
                <FormItem>
                  {getFieldDecorator('phone', {
                    rules: [{ required: true, message: '请更改花名册' }],
                    initialValue: userDetail ? userDetail.phone : null
                  })(
                    <Input disabled style={{ width: "200px" }} />
                  )}
                </FormItem>
              </Col>
              <Col span={4} style={{ textAlign: "right", paddingRight: "10px", lineHeight: "32px" }}>
                所属部门：
                        </Col>
              <Col span={8}>
                <FormItem>
                  {getFieldDecorator('department_name', {
                    rules: [{ required: true, message: '请更改花名册' }],
                    initialValue: userDetail ? userDetail.department_name : null
                  })(
                    <Input disabled style={{ width: "200px" }} />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row>
              <Col span={4} style={{ textAlign: "right", paddingRight: "10px", lineHeight: "32px" }}>
                角色：
                        </Col>
              <Col span={8}>
                <FormItem>
                  {getFieldDecorator('role_id', {
                    rules: [{ required: true, message: '请选择角色' }],
                    initialValue: userDetail ? userDetail['role_id'] : null
                  })(
                    <Select
                      filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                      onChange={handleSelectChange.bind(this, 'role_id')}
                      showSearch
                      style={{ width: "200px" }}>
                      {
                        initUser.Roles && initUser.Roles.map(item => {
                          return (
                            <Select.Option key={item.Value} value={item.Value}>
                              {item.Text}
                            </Select.Option>
                          )
                        }
                        )
                      }
                    </Select>
                  )}
                  {/* {getFieldDecorator('role_id', {
                    rules: [{ required: true, message: '请选择角色' }],
                    initialValue: userDetail ? userDetail['role_id'] : null
                  })(
                    <Select style={{ width: "200px" }} onChange={handleSelectChange.bind(this, 'role_id')}>
                      {
                        initUser.Roles.map((item) => (
                          <Option key={item.Value} value={item.Value}>{item.Text}</Option>
                        )
                        )
                      }
                    </Select>
                  )} */}
                </FormItem>
              </Col>
              <Col span={4} style={{ textAlign: "right", paddingRight: "10px", lineHeight: "32px" }}>
                密码：
                        </Col>
              <Col span={8}>
                <FormItem>
                  {getFieldDecorator('password', {
                    rules: [{ required: true, message: '请输入密码' }],
                    initialValue: userDetail ? userDetail['password'] : null
                  })(
                    <Input style={{ width: "200px" }} />
                  )}
                </FormItem>
              </Col>
            </Row>
          </Form>
          {/*<Row gutter={16}>
                         <Col span={12}>
                             <label>工号</label>
                             <Input type="number" defaultValue={userDetail ? userDetail.code : null} className="fixedModalInput" onChange={handleInputChange.bind(this, 'code')} />
                         </Col>
                         <Col span={12}>
                             <label style={{marginLeft: -13}}>用户名</label>
                             <Input defaultValue={userDetail ? userDetail['user_name'] : null} className="fixedModalInput" onChange={handleInputChange.bind(this, 'user_name')} />
                         </Col>
                     </Row>
                     <Row gutter={16} style={{marginTop: 10}}>
                         <Col span={12}>
                             <label>密码</label>
                             <Input type="password" defaultValue={userDetail ? userDetail['password'] : null} className="fixedModalInput" onChange={handleInputChange.bind(this, 'password')} />
                         </Col>
                         <Col span={12}>
                             <label>邮箱</label>
                             <Input type="email" defaultValue={userDetail ? userDetail['email'] : null} className="fixedModalInput" onChange={handleInputChange.bind(this, 'email')} />
                         </Col>
                     </Row>
                     <Row gutter={16} style={{marginTop: 10}}>
                         <Col span={12}>
                             <label>生日</label>
                             <DatePicker defaultValue={userDetail && userDetail['birthday'] ? moment(userDetail['birthday']) : null} placeholder="选择日期" className="fixedModalInput" onChange={onDatePickerChange} />
                         </Col>
                         <Col span={12}>
                             <label>电话</label>
                             <Input type="number" defaultValue={userDetail ? userDetail['phone'] : null} className="fixedModalInput" onChange={handleInputChange.bind(this, 'phone')} />
                         </Col>
                     </Row>
                     <Row gutter={16} style={{marginTop: 10}}>
                         <Col span={12}>
                             <label>角色</label>
                             <Select className="fixedModalInput" defaultValue={userDetail ? userDetail['role_id'] : "选择角色"}  onChange={handleSelectChange.bind(this, 'role_id')}>
                                 {
                                     initUser.Roles.map((item) => (
                                            <Option key={item.Value} value={item.Value}>{ item.Text }</Option>
                                        )
                                     )
                                 }
                             </Select>
                         </Col>
                         <Col span={12}>
                             <label style={{marginLeft: -27}}>所属部门</label>
                           {
                               departmentsList ?
                                   <TreeSelect
                                      style={{ width: 200, marginLeft: 10 }}
                                      // value={this.state.value}
                                      defaultValue={userDetail ? userDetail['department_name'] : "根据部门选择"} 
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder="根据部门选择"
                                      allowClear
                                      treeDefaultExpandAll
                                      onChange={handleSelectChange.bind(this.id, 'department_id')}
                                  >
                                       { this.renderTreeNodes(departmentsList) }
                                  </TreeSelect>
                                  :
                                  <Spin />
                           }
                         </Col>
                     </Row>*/}
        </div>
      </Modal>
    )
  }
}
UsereModal = Form.create()(UsereModal)
export default UsereModal;



// WEBPACK FOOTER //
// ./src/components/SystemSetting/UserModal.js